import React, { Component, ReactNode } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import { Icon, IconName } from "@formant/ui/component/common/Icon";

import { Button } from "../common/Button";
import styles from "./LinkListItem.scss";

export interface ILinkListItemProps extends ITestableComponentProps {
    icon: IconName | ReactNode;
    title: string;
    to: string;
    onClicked?: () => void;
    className?: string;
    buttonClassName?: string;
    children?: React.ReactNode;
}

export class LinkListItem extends Component<ILinkListItemProps> {
    public render() {
        const {
            icon,
            title,
            to,
            onClicked,
            buttonClassName,
            className,
            children,
        } = this.props;

        return (
            <div
                className={classnames(styles["link-list-item"], className)}
                data-testid={this.props["data-testid"]}
            >
                <Button
                    className={classnames(styles.button, buttonClassName)}
                    to={to}
                    onClicked={onClicked}
                    activeClassName={styles.active}
                >
                    <div className={styles.icon}>
                        {typeof icon === "string" ? (
                            <Icon name={icon as IconName} size="18" />
                        ) : (
                            icon
                        )}
                    </div>
                    <div className={styles.title}>{title}</div>
                </Button>
                {children && <div className={styles.extra}>{children}</div>}
            </div>
        );
    }
}
